import styled from 'styled-components';
import {StyledButton} from "../ConversationItem/ConversationItem.styled";

interface OpenProps {
    open: boolean;
}

export const StyledReportProblemWrapper = styled.div<OpenProps>`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    padding: 0;
    gap: 20px;
    //width: 240px;
    height: auto;
    margin-top: 20px;
`;

export const StyledReportProblemButton = styled(StyledButton)`
    background: ${({theme}) => theme.palette.background.subtle};
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    position: relative;
    top: 1px;

    &:hover {
        background: ${({theme}) => theme.palette.action.hover};
    }

    svg {
        width: 20px;
        height: 20px;
        margin-right: 4px;
    }
`;
